<template>
  <tabs>
    <tab name="Info">
      <product-info-editor :product.sync="product"
                           :categories="categories"></product-info-editor>
    </tab>

    <tab name="Gallery">
      <product-images :product.sync="product"></product-images>
    </tab>

    <tab name="Videos">
      <products-videos :product.sync="product"></products-videos>
    </tab>

    <tab name="Specs">
      <product-specs :product.sync="product"></product-specs>
    </tab>

    <tab name="Benefits">
      <product-benefits :product.sync="product"></product-benefits>
    </tab>

    <tab name="Downloads">
      <product-downloads :product.sync="product"></product-downloads>
    </tab>

    <tab name="Prices">
      <product-prices :product.sync="product"></product-prices>
    </tab>

    <tab name="Loader Hitches">
      <product-hitches :product.sync="product"></product-hitches>
    </tab>
  </tabs>
</template>

<script>
import ProductImages from "./ProductImages";
import ProductInfoEditor from "./ProductInfoEditor";
import ProductsVideos from "./ProductsVideos";
import ProductSpecs from "./ProductSpecs";
import ProductBenefits from "./ProductBenefits";
import ProductDownloads from "./ProductDownloads";
import ProductPrices from "./ProductPrices";
import ProductHitches from "./ProductHitches.vue";

export default {
  name: "ProductEditor",
  components: {
    ProductHitches,
    ProductPrices,
    ProductDownloads,
    ProductBenefits,
    ProductSpecs,
    ProductsVideos,
    ProductInfoEditor,
    ProductImages
  },
  data() {
    return {
      loading: false,
      product: {
        images: [],
        videos: [],
        specs: [],
        benefits: [],
        downloads: [],
        options: [],
        loader_hitch_options: [],
        spare_parts: [],
      },
      categories: []
    }
  },
  mounted() {
    this.product = JSON.parse($("#product").text())
    this.categories = JSON.parse($("#categories").text())
  },
  methods: {},
  computed: {}
}
</script>
